import { Box,  Flex,  Text } from "@chakra-ui/react";
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Markdown from "../../components/markdown";
import "github-markdown-css/github-markdown-light.css"
import axios from "axios";

const getMarkdownUrl = (name: string) => {
  if (!name) {
    return ''
  }
  return `https://cogagent.aminer.cn/static/blog/${name.replace(".md", "")}.md`
}


function Home() {
  const params = useParams()
  const nav = useNavigate()
  const url = getMarkdownUrl(params.name as string)
  const [content, setContent] = useState('')
  useEffect(() => {
    if (!url) {
      nav("/404")
    } else {
      axios.get(url, {
        headers: {
            "Content-Type": "*",
            "Access-Control-Allow-Origin": "*",
            "Accept":	"*/*",
            "Access-Control-Allow-Methods": "*",
            "Access-Control-Allow-Headers": "*"
        }
      }).then(res => {
        setContent(res.data)
      }).catch(err => {
        nav("/404")
      })
    }
  }, [url, nav])

  useLayoutEffect(() => {
    setTimeout(() => {
      const title = document.querySelector("h1")?.textContent
  
      if (title) {
        document.title = title
      }
    }, 500)
  }, [])
  
  return (
    <Flex justify="center">
      
    <Box className="markdown-body" maxW="950px" w="80%">
      <Markdown content={content} />
    </Box>
    </Flex>
  );
}

export default Home;
